module.exports = __webpack_public_path__ + "static/media/emojiNeutral.0ecb0d96.svg";